class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. The morphed children
  // (inserted from the /cart/add.js sections response in renderContents) are
  // post-add, but they don't expose the full cart shape we need for the event
  // payload. So we keep an explicit /cart.json fetch on open. Migrating to the
  // factory + filter would require re-rendering the notification element
  // itself in sections, which is out of scope for this PR.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {
    document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  this.renderAllCartItems();

  if (this.header) this.header.reveal();

  this.open();
}
async renderAllCartItems() {
  const container = document.getElementById('cart-notification-products');

  if (!container) return;

  try {
    const response = await fetch(`${routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) return;

    const cart = await response.json();

    container.innerHTML = '';

    cart.items.forEach((item, index) => {
      const card = document.createElement('div');
      card.className = 'cart-notification-product-card';

      /* =========================
         IMMAGINE
      ========================= */

      const imageLink = document.createElement('a');
      imageLink.href = item.url;

      if (item.image) {
        const image = document.createElement('img');

        image.className = 'cart-notification-product-card__image';
        image.src = item.image;
        image.alt = item.product_title || '';
        image.loading = 'lazy';

        imageLink.appendChild(image);
      }

      /* =========================
         INFORMAZIONI
      ========================= */

      const info = document.createElement('div');
      info.className = 'cart-notification-product-card__info';

      /* TITOLO */

      const title = document.createElement('a');

      title.className = 'cart-notification-product-card__title';
      title.href = item.url;
      title.textContent = item.product_title;

      info.appendChild(title);

      /* VARIANTE */

      if (
        item.variant_title &&
        item.variant_title !== 'Default Title'
      ) {
        const variant = document.createElement('p');

        variant.className =
          'cart-notification-product-card__variant';

        variant.textContent = item.variant_title;

        info.appendChild(variant);
      }

      /* =========================
         CONTROLLI QUANTITÀ
      ========================= */

      const controls = document.createElement('div');
      controls.className =
        'cart-notification-product-card__controls';

      const quantityBox = document.createElement('div');
      quantityBox.className =
        'cart-notification-product-card__quantity-box';

      /* MENO */

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className =
        'cart-notification-product-card__quantity-button';
      minus.setAttribute('aria-label', 'Riduci quantità');
      minus.textContent = '−';

      /* NUMERO */

      const quantityNumber = document.createElement('span');
      quantityNumber.className =
        'cart-notification-product-card__quantity-number';

      quantityNumber.textContent = item.quantity;

      /* PIÙ */

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.className =
        'cart-notification-product-card__quantity-button';
      plus.setAttribute('aria-label', 'Aumenta quantità');
      plus.textContent = '+';

      quantityBox.appendChild(minus);
      quantityBox.appendChild(quantityNumber);
      quantityBox.appendChild(plus);

      /* =========================
         CESTINO
      ========================= */

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className =
        'cart-notification-product-card__remove';

      remove.setAttribute(
        'aria-label',
        'Rimuovi prodotto dal carrello'
      );

      remove.innerHTML = `
        <svg
          viewBox="0 0 24 24"
          width="19"
          height="19"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      `;

      controls.appendChild(quantityBox);
      controls.appendChild(remove);
      const price = document.createElement('div');
price.className = 'cart-notification-product-card__price';

const formattedPrice = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR'
}).format(item.final_line_price / 100);

price.textContent = formattedPrice;

controls.appendChild(price);

      info.appendChild(controls);

      /* =========================
         COSTRUZIONE CARD
      ========================= */

      card.appendChild(imageLink);
      card.appendChild(info);

      container.appendChild(card);

      /* =========================
         FUNZIONE AGGIORNAMENTO
      ========================= */

      const updateQuantity = async (newQuantity) => {
        if (newQuantity < 0) return;

        minus.disabled = true;
        plus.disabled = true;
        remove.disabled = true;

        try {
          const updateResponse = await fetch(
            `${routes.cart_change_url}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                line: index + 1,
                quantity: newQuantity
              })
            }
          );

          if (!updateResponse.ok) {
            throw new Error('Errore aggiornamento carrello');
          }

          const updatedCart = await updateResponse.json();

          /* aggiorna pallino quantità header */

          const bubbles =
            document.querySelectorAll('#cart-icon-bubble');

          bubbles.forEach((bubble) => {
            const count =
              bubble.querySelector('.cart-count-bubble');

            if (count) {
              const visibleCount = count.querySelector(
                'span[aria-hidden="true"]'
              );

              if (visibleCount) {
                visibleCount.textContent =
                  updatedCart.item_count;
              }
            }
          });

          /* ricrea tutti i prodotti */

          await this.renderAllCartItems();

          /* evento aggiornamento carrello */

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: updatedCart
              }
            })
          );

        } catch (error) {
          console.error(
            'Errore aggiornamento quantità:',
            error
          );

          minus.disabled = false;
          plus.disabled = false;
          remove.disabled = false;
        }
      };

      /* MENO */

      minus.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        updateQuantity(item.quantity - 1);
      });

      /* PIÙ */

      plus.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        updateQuantity(item.quantity + 1);
      });

      /* CESTINO */

      remove.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        updateQuantity(0);
      });
    });

  } catch (error) {
    console.error(
      'Errore caricamento mini carrello:',
      error
    );
  }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
